export enum MediaType {
    /**
     * The audio type.
     */
    AUDIO = 'audio',

    /**
     * The video type.
     */
    VIDEO = 'video',

    /**
     * The application type (data over bridge channel).
     */
    APPLICATION = 'application'
}
